import { Type } from "@sinclair/typebox";
export const Nullable = (schema) => Type.Union([schema, Type.Null()]);
export const NullableAndOptional = (schema) => Type.Union([schema, Type.Null(), Type.Optional(schema)]);
export const SupportedCurrencySchema = Type.Union([
    Type.Literal("USD"),
    Type.Literal("HKD"),
    Type.Literal("SGD"),
    Type.Literal("AUD"),
]);
